import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SelectedGradeStateService } from '@app/infrastructure/core/services/state/selected-grade-state.service';
import { UserStateService } from '@app/infrastructure/core/services/state/user-state.service';
import { GradingPeriodDTO } from '@app/infrastructure/models/grading-period';
import { IStudentListSortDTO } from '@app/infrastructure/models/student';
import { GradeLevel, GradeRoute } from '@models/grade-level';
import { INavigation } from '@models/navigation';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';

@Component({
  selector: 'app-grading-period-selector',
  template: `
    <app-grading-period-selector-presentation
      [gradingPeriods]="gradingPeriods"
      [link]="gradingPeriodLink"
      (selectionEvent)="selectionChanged($event)"
    ></app-grading-period-selector-presentation>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GradingPeriodSelectorSmartComponent {
  @Output() selectionEvent: EventEmitter<IStudentListSortDTO> =
    new EventEmitter<IStudentListSortDTO>();
  public gradingPeriods: GradingPeriodDTO[];
  public classroomId: string;
  public gradingPeriodLink: string = '';

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private userStateService: UserStateService,
  ) {
    const gradingPeriods = 'gradingPeriods';
    this.gradingPeriods = this.route.snapshot.data[gradingPeriods];
    this.classroomId = this.route.snapshot.params?.classroomId;
  }

  selectionChanged(value: IStudentListSortDTO) {
    this.navigate(value);
  }

  navigate(value) {
    const routeParams = this.isStudent()
      ? this.studentGradesUrl(value)
      : this.teacherUnitsUrl(value);

    this.router.navigate(routeParams, {
      relativeTo: this.route,
    });
  }

  studentGradesUrl(value) {
    return ['grading-period', value.gradingPeriodId];
  }

  teacherUnitsUrl(value) {
    return ['grading-period', value.gradingPeriodId, 'units'];
  }

  isStudent() {
    return this.userStateService.userSession.student ? true : false;
  }
}
